import Widget from "./Widget";
import { gql } from "@apollo/client";
import Text from "@src/lib/ui/Text";

import { Skeleton } from "@src/lib/ui/Skeleton";
import { useAdminEmployeesCountQuery } from "./TotalUsersWidget.generated";
import { Badge } from "@src/lib/ui/Badge";
import { useMemo } from "react";
import UsersOutlineIcon from "@src/lib/icons/18px/users-outline";

const TotalUsersWidget: React.FC = () => {
  const variables = useMemo(() => {
    const pastWeekStartDate = new Date(
      new Date().setDate(new Date().getDate() - 7),
    );
    return {
      pastWeekStartDate: pastWeekStartDate.toISOString(),
    };
  }, []);
  const { data, loading } = useAdminEmployeesCountQuery({
    variables,
  });
  const employeeCountChange = data?.PastWeekEmployees?.totalCount || 0;

  return (
    <Widget
      title="Total Users"
      Icon={UsersOutlineIcon}
      href={{ pathname: "/users" }}
    >
      {loading ? (
        <Skeleton className="h-[34px] w-10 rounded-md" />
      ) : (
        <div className="flex flex-row items-center gap-1 align-middle">
          <Text variant="display-bold">{data?.TotalEmployees?.totalCount}</Text>
          <EmployeeCountChange diff={employeeCountChange} />
        </div>
      )}
    </Widget>
  );
};

const EmployeeCountChange: React.FC<{ diff: number }> = ({ diff }) => {
  const zero = diff === 0;
  const diffText = zero ? "0" : diff > 0 ? `+${diff}` : `${diff}`;

  return (
    <>
      <Badge
        variant={diff > 0 ? "success" : diff < 0 ? "destructive" : "secondary"}
      >
        <Text variant="fine-print-title">{diffText}</Text>
      </Badge>
      <Text variant="fine-print-description" className="text-gray-8">
        this week
      </Text>
    </>
  );
};

gql`
  query AdminEmployeesCount($pastWeekStartDate: Date!) {
    TotalEmployees: AdminEmployees {
      totalCount
    }
    PastWeekEmployees: AdminEmployees(startDate: $pastWeekStartDate) {
      totalCount
    }
  }
`;

export default TotalUsersWidget;
